// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhr_ss","PhotoTitleEditForm__cancelBtn":"iy_b bhr_sw bhr_sv"};